export default __webpack_public_path__ + "static/media/hht1_ep19_book_wp_02.d3e41086.jpg";